import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseFile: {
    id: 'chooseFile',
    defaultMessage: 'Choose file'
  },
  chooseNewFile: {
    id: 'chooseNewFile',
    defaultMessage: 'Choose new file'
  },
  noUploadedFile: {
    id: 'noUploadedFile',
    defaultMessage: 'No file chosen'
  },
  uploading: {
    id: 'uploading',
    defaultMessage: 'Uploading'
  },
  uploadFailed: {
    id: 'uploadFailed',
    defaultMessage: 'Upload failed'
  },
});
